import { render } from "./TabGroup.vue?vue&type=template&id=58b514e7&scoped=true"
import script from "./TabGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./TabGroup.vue?vue&type=script&setup=true&lang=js"

import "./TabGroup.vue?vue&type=style&index=0&id=58b514e7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58b514e7"],['__file',"src/components/Atoms/TabGroup.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "58b514e7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('58b514e7', __exports__)) {
    api.reload('58b514e7', __exports__)
  }
  
  module.hot.accept("./TabGroup.vue?vue&type=template&id=58b514e7&scoped=true", () => {
    api.rerender('58b514e7', render)
  })

}


export default __exports__